/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for ticket search:
 *   * ALL : All fields
 *   * NUMBER_TICKET
 *   * STATION_NAME
 *   * TYPE_PANNE
 *   * STATE
 */
export enum TicketSearchFilter {
  ALL = 'ALL',
  NUMBER_TICKET = 'NUMBER_TICKET',
  STATION_NAME = 'STATION_NAME',
  TYPE_PANNE = 'TYPE_PANNE',
  STATE = 'STATE'
}
